import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-grid-exports',
  templateUrl: './grid-exports.component.html',
  styleUrls: ['./grid-exports.component.css']
})
export class GridExportsComponent implements OnInit {
    argType;

    argValue;

    public itemsListGridExports: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadGridExports() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListGridExports = await this.datatask.Post(1879, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadGridExports();
    }

    ngOnInit() {
        this.init();
    }
}
